import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Table, Form, Button } from 'react-bootstrap';

const AddressForm = ({ company }) => {
  const getValue = (attributeName) => {
    return company[attributeName] ? company[attributeName] : '';
  };

  return (
    <>
      <Row className="col-12">
        <Col md="12">
          <h6 className="title-dashboard">Endereço</h6>
        </Col>
        <Col md="12">
          <hr className="line"></hr>
        </Col>
      </Row>
      <Row className="">
        <Col md={3}>
          <Form.Group>
            <Form.Label>CEP:</Form.Label>
            <Form.Control
              as="input"
              disabled={true}
              value={getValue('address_zipcode')}
            >
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={7}>
          <Form.Group>
            <Form.Label>Endereço:</Form.Label>
            <Form.Control
              as="input"
              disabled={true}
              value={getValue('address')}
            >
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Nº:</Form.Label>
            <Form.Control
              as="input"
              disabled={true}
              value={getValue('address_number')}
            >
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Estado:</Form.Label>
            <Form.Control
              as="input"
              disabled={true}
              value={company.address_state}
            >
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Cidade:</Form.Label>
            <Form.Control
              as="input"
              disabled={true}
              value={getValue('address_city')}
            >
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Bairro:</Form.Label>
            <Form.Control
              as="input"
              disabled={true}
              value={getValue('address_neighborhood')}
            >
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Complemento:</Form.Label>
            <Form.Control
              as="input"
              disabled={true}
              value={getValue('address_complement')}
            >
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default AddressForm;